import React, { useState, useContext, useEffect, useRef } from 'react';
import { Redirect, Route, useHistory } from 'react-router-dom';
import { IonApp, useIonRouter, IonRouterOutlet, IonSplitPane, IonTabs, IonTabBar, IonTabButton, IonContent,IonLabel, IonGrid, IonItem, IonPage, IonRefresher, IonRefresherContent} from '@ionic/react';

import { IonInput, IonButton, IonRow, IonCol } from '@ionic/react';

import { NativeBiometric } from "capacitor-native-biometric";
import { BiometryType } from "capacitor-native-biometric";
import { Preferences } from '@capacitor/preferences';

import './pages/css/layout.css';


//import { Plugins } from '@capacitor/core';
import { PrivateRoute_merchant } from './components/PrivateRoute_merchant';
import { PrivateRoute_client } from './components/PrivateRoute_client';

import { Home } from './pages/zPublic/views/Home';
import UserLogin from './pages/zPublic/views/clientLogin';
import MerchantLogin from './pages/zPublic/views/merchantLogin';

import {ConfirmMerchantLogout} from './pages/zPublic/components/MerchantLogout';
import { ConfirmClientLogout } from './pages/zPublic/components/ClientLogout';

import Internal_ProfileSetting from './pages/zInternal_Features/merchant/views/internal_profileSetting';

import {  Hotel_SideMenu } from './pages/hotel/merchant/components/Hotel_SideMenu';
import Hotel_MerchantHomePage from './pages/hotel/merchant/views/hotel_merchantMainPageApp';
//import Hotel_ProfileSetting from './pages/hotel/merchant/views/hotel_profileSetting';
import Hotel_AccountSetting from './pages/hotel/merchant/views/hotel_accountSetting';

import {  ProService_SideMenu } from './pages/proService/merchant/components/ProService_SideMenu';
import ProService_MerchantHomePage from './pages/proService/merchant/views/proService_merchantMainPageApp';
//import ProService_ProfileSetting from './pages/proService/merchant/views/proService_profileSetting';
import ProService_AccountSetting from './pages/proService/merchant/views/proService_accountSetting';

import {  Retail_SideMenu } from './pages/retail/merchant/components/Retail_SideMenu';
import Retail_MerchantHomePage from './pages/retail/merchant/views/retail_merchantMainPageApp';
//import Retail_ProfileSetting from './pages/retail/merchant/views/retail_profileSetting';
import Retail_AccountSetting from './pages/retail/merchant/views/retail_accountSetting';
import Retail_Tutorials from './pages/retail/merchant/views/Retail_Tutorials';

import {  JobBoard_SideMenu } from './pages/jobBoard/merchant/components/JobBoard_SideMenu';
import JobBoard_MerchantHomePage from './pages/jobBoard/merchant/views/JobBoard_merchantMainPageApp';
import JobBoard_ProfileSetting from './pages/jobBoard/merchant/views/JobBoard_ProfileSettings';
import JobBoard_AccountSetting from './pages/jobBoard/merchant/views/JobBoard_AccountSettings';
import JobBoard_Tutorials from './pages/jobBoard/merchant/views/JobBoard_Tutorials';


import Hotel_PrivacyStatement from './pages/zPublic/components/PrivacyStatement_static';
import Contact_Us from './pages/zPublic/components/Ghana_Verified_Contact_Us';


import {  Client_SideMenu } from './pages/client/components/client_sideMenu';
import ClientHomePage from './pages/client/views/clientMainPageApp';
import Client_ProfileSetting from './pages/client/views/client_profileSetting';
import Client_AccountSetting from './pages/client/views/client_accountSetting';

import { PublicMerchantID_provider, Public_MerchantID_Context } from './storeState/public_merchantID_context';
import { Auth_ClientID_context } from './storeState/auth_clientID_context';
import { Auth_MerchantID_context } from './storeState/auth_merchantID_context';

import ProServiceMerchant_Homepage from './pages/zPublic/components/Homepage_proService';
import Hotels_Homepage from './pages/zPublic/components/Homepage_hotel';

import { Home_ProfessionalServicesList } from "./pages/zPublic/views/Home";
import { Home_HotelsList } from "./pages/zPublic/views/Home";

import { MerchantLoginCredentials } from './pages/zPublic/components/LoginCredentials_merchant';

import {Applicant_OfferLetterModal} from './pages/zPublic/components/Modal_Applicant_OfferLetter';

import {Push_Notification} from './pages/zInternal_Features/merchant/components/PushNotifictions';
import {Subscription_Alert} from './pages/zInternal_Features/merchant/components/Modal_Subscription_Alert';

import { Geolocation } from '@capacitor/geolocation';


import Cookie from 'universal-cookie';
import { IonReactRouter } from '@ionic/react-router';


let cookies = new Cookie();

if (typeof window !== 'undefined') {

    //alert("IN WINDOW PROCESS");
    
    window.process = { env: { NODE_ENV: 'production' } };
  }


async function removeStorageCredentials() {


    await Preferences.remove({ key: 'accountID' });
    await Preferences.remove({ key: 'company_phoneNumber' });
    await Preferences.remove({ key: 'employeeID' });
    await Preferences.remove({ key: 'employee_first_name' });
    await Preferences.remove({ key: 'employee_last_name' });
    await Preferences.remove({ key: 'employee_company' });
    await Preferences.remove({ key: 'employee_createdBy' });
    await Preferences.remove({ key: 'schemaName' });
    await Preferences.remove({ key: 'isAuthenticated' });
    await Preferences.remove({ key: 'accessRights' });
    await Preferences.remove({ key: 'loginUsername_authenticated' });
    await Preferences.remove({ key: 'loginPassword_authenticated' });
    await Preferences.remove({ key: 'isBiometricFingerprintAvilable' });
    await Preferences.remove({ key: 'biometricFingerprint' });
    await Preferences.remove({ key: 'device' });
    await Preferences.remove({ key: 'sessionID' });
    await Preferences.remove({ key: 'baseURL' });
    await Preferences.remove({ key: 'capability' });
    await Preferences.remove({ key: 'feature' });
    await Preferences.remove({ key: 'cartList' });
    await Preferences.remove({ key: 'fcm_token' });
    await Preferences.remove({ key: 'latitude_current' });
    await Preferences.remove({ key: 'longitude_current' });
    await Preferences.remove({ key: 'chatID_list' });
    await Preferences.remove({ key: 'websocket' });
    await Preferences.remove({ key: 'initial_setup' });
    await Preferences.remove({ key: 'selected_tutorial' });
    await Preferences.remove({ key: 'subscription' });
    
    let remove_cookie = null;

    cookies.remove('session', remove_cookie);


}

function setStorageCredentials_sessionID(event) {

    //alert('In setStorageCredentials_sessionID');
    //alert(event);

    Preferences.set({
        key: 'sessionID',
        value: event,
    })
}

async function setAppDevice_device(event) {

    Preferences.set({
        key: 'device',
        value: event,
    })
    
}

async function setAppDevice_url(event) {

    Preferences.set({
        key: 'baseURL',
        value: event,
    })
    
}

async function setCoordinates(event) {

    Preferences.set({
        key: 'latitude_current',
        value: event[0],
    })
    Preferences.set({
        key: 'longitude_current',
        value: event[1],
    })
    
}



//class App extends React.Component   {
//const App: React.FC<AppProps> = (props: any) => {
export function App () {

    //alert("IN APP");

    let publicZSavaContext = useContext(Public_MerchantID_Context);
    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);
    let authenticatedClient_context = useContext(Auth_ClientID_context);

    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);
    
    let [homeView, setHomeView] = useState('0');
    let [isBiometric_fingerprintAvailable, setIsBiometric_fingerprintAvailable ] = useState(authenticatedMerchent_context.isBiometric_fingerprintAvailable);
    let [biometric_fingerprint, setBiometric_fingerprint] = useState(authenticatedMerchent_context.biometric_fingerprint);
    let [device, setDevice ] = useState(authenticatedMerchent_context.device);
    let [entryPaths, setEntryPaths] = useState([
        '/', '/hotel_merchantMainPageApp', '/hotel_merchantMainPageApp/overviewTab', '/hotel_merchantMainPageApp/checkIn_checkOutTab',
        '/hotel_merchantMainPageApp/cleaningServicesTab', '/hotel_merchantMainPageApp/reservationsTab' 
    ]);

    let [authenticated, setAuthenticated ] = useState(null);


    let [merchantLoginModal, setMerchantLoginModal] = useState(true);
    let [fingerprintLoginModal, setFingerprintLoginModal] = useState(true);

    let [viewApplicant_OfferModal, setViewApplicant_OfferModal] = useState(false);
    let [applicant_merchantID, setAppliant_merchantID] = useState(null);
    let [applicant_requisitionID, setAppliant_requisitionID] = useState(null);
    let [applicant_applicationID, setAppliant_applicationID] = useState(null);

    let [notificationData, setNotificationData] = useState(null);

    let history = useHistory();
    let router = useIonRouter();

    //let [landingPage, setLandingPage] = useState('/home');

    
    /*let [acctID, setData_acctID] = useState<string | null>(null);
    let [employeeID, setData_employeeID] = useState<string | null>(null);
    let [schema, setData_schema] = useState<string | null>(null);
    let [isAuth, setData_isAuth] = useState<string | null>(null);
    let [access, setData_accessRights] = useState<string | null>(null);*/

    let acctID = '' || null;
    let employeeID = '' || null;
    let schema = '' || null;
    let isAuth = '' || null;
    let access = '' || [];


    if(authenticatedClient_context.authenticated === 'yesc')
    {

        acctID = authenticatedClient_context.acctID;
        schema = authenticatedClient_context.schema;
        isAuth = authenticatedClient_context.authenticated;
        access = authenticatedClient_context.accessRights;

    }
    else if(authenticatedMerchent_context.authenticated === 'T2' || authenticatedMerchent_context.authenticated === 'T1' )
    {

        acctID = authenticatedMerchent_context.acctID;
        employeeID = authenticatedMerchent_context.employeeID
        schema = authenticatedMerchent_context.schema;
        isAuth = authenticatedMerchent_context.authenticated;
        access = authenticatedMerchent_context.accessRights;
    }

    useEffect(() => {
        
        NativeBiometric.isAvailable().then(
            (result) => {
                
            const isAvailable = result.isAvailable;
            const isAvailable_isFingerPrint = result.biometryType == BiometryType.FINGERPRINT;
            //const isFaceId = result.biometryType == BiometryType.FACE_ID;

            //alert(isAvailable);

                if(isAvailable == true) 
                {
                    //alert("is isAvailable = true")

                    setAppDevice_url(window.location.origin+"/");
                    authenticatedMerchent_context.changeBaseURL(window.location.origin+"/");
                    setAppDevice_device('mobile');
                    //authenticatedMerchent_context.changeDevice('mobile');



                }
                else if (isAvailable == false) 
                {
                    //alert("is isAvailable = false")
                    //alert(window.location);

                    setAppDevice_url(window.location.origin+"/");
                    authenticatedMerchent_context.changeBaseURL(window.location.origin+"/");
                    setAppDevice_device('desktop');
                    //authenticatedMerchent_context.changeDevice('desktop');

                }

            },            
            (error) =>
            {
                //alert("FINGERPRINT not available");
                //alert(window.location);

                setAppDevice_url(window.location.origin+"/");
                setAppDevice_device('desktop');
                authenticatedMerchent_context.changeBaseURL(window.location.origin+"/");
                //authenticatedMerchent_context.changeDevice('desktop');

            }
            )

            
            getCurrentLocation();
    
    
            // let position =  Geolocation.getCurrentPosition();
    
            // //alert(JSON.stringify(position, null, 2));
    
            // //setCoordinates(position.coords);
            // alert(position.coords);
            // alert(position.coords.latitude);
            // alert(position.coords.longitude);

            // authenticatedMerchent_context.changeLatitudeCurrent(position.coords.latitude);
            // authenticatedMerchent_context.changeLongitudeCurrent(position.coords.longitude);


        }, [])


        async function getCurrentLocation() {
            try{
        
                let position = await Geolocation.getCurrentPosition();
    
                //alert(JSON.stringify(position, null, 2));
        
                //setCoordinates(position.coords);
                //alert(position.coords);
                //alert(position.coords.latitude);
                //alert(position.coords.longitude);
    
                setCoordinates([position.coords.latitude, position.coords.longitude]);

                authenticatedMerchent_context.changeLatitudeCurrent(position.coords.latitude);
                authenticatedMerchent_context.changeLongitudeCurrent(position.coords.longitude);
        
            }
            catch(error)
            {
                console.error('Error getting location:', error);
            }
        }

        function handleRefresh(event)
        {
            // Optional: Delay to show the spinner briefly
            setTimeout(() => {
              event.detail.complete();   // Stop the spinner
              window.location.reload();  // Reload the entire app
            }, 500);
        }

    useEffect(() => {

        //alert('in use effect');
        //alert(window.location.origin+"/");
        //alert(window.location.pathname);
        //alert(authenticatedMerchent_context.authenticated);
        //alert(auth);

        if(window.location.pathname.includes('offer_letter'))
        {

             //alert( window.location.href);
            // alert( window.location.pathname);
            // alert( window.location.url);

            let cols = window.location.href.split('#');

            setAppliant_merchantID(cols[1]);
            setAppliant_requisitionID(cols[2]);
            setAppliant_applicationID(cols[3]);
            setViewApplicant_OfferModal(true);
            
            //history.push('/offer_letter#'+cols[1]+'#'+cols[2]+'#'+cols[3]);

        }
        else if (window.location.pathname != '/privacy_statement' && window.location.pathname != '/contact' && window.location.pathname != '/home' && window.location.pathname != '/jobs' &&
                window.location.pathname != '/hotel_profileSetting' && window.location.pathname != '/hotel_accountSetting' && window.location.pathname != '/retail_profileSetting' && 
                window.location.pathname != '/retail_accountSetting' && window.location.pathname != 'jobBoard_profileSetting' && window.location.pathname != 'jobBoard_accountSetting' && 
                window.location.pathname != '/logout') 
        {
            // alert("inside 1");
            // alert(window.location.pathname);
            // alert(authenticatedMerchent_context.authenticated);
            
            history.push('/');

            router.push(window.location.pathname, 'forward', 'replace');
        }


     }, []);

     useEffect(() => {
        

        if(notificationData != null)
        {
            alert(notificationData);

            setNotificationData(null);
        }
        

     }, [notificationData])

     
     //alert("In App");
   //alert(authenticatedMerchent_context.authenticated);
   // alert(authenticatedMerchent_context.acctID);
    //  alert(authenticatedMerchent_context.initialSetup);
    // alert(authenticatedMerchent_context.initialSetup[0]);
    // alert(authenticatedMerchent_context.initialSetup[1]);
     //alert(window.location.pathname);
    // alert(authenticatedMerchent_context.loginUsername);
    // alert(authenticatedMerchent_context.sessionID);
    //alert(authenticatedMerchent_context.subscription.payStatus);
    //alert(authenticatedMerchent_context.subscription.transactionTotal);


    // if (window.location.pathname == '/logout') {
    //     return <IonApp>
    //             <IonReactRouter>
    //                 <IonRouterOutlet >
    //                     <Route exact path="/logout" render={() => <ConfirmMerchantLogout  data={{
    //                                         acctID: authenticatedMerchent_context.acctID,
    //                                         schema: authenticatedMerchent_context.schema,
    //                                         sessionID: authenticatedMerchent_context.sessionID,
    //                                         baseURL: authenticatedMerchent_context.baseURL}}/>}/> 
    //                 </IonRouterOutlet >
    //                 </IonReactRouter>

    //             </IonApp>; // or null
    //   }
    

    if (authenticatedMerchent_context.authenticated == null) {
        return <IonApp>
                <IonReactRouter>
                    <IonRouterOutlet >
                        <Route exact path="/home" render={() => <Home data={{
                            status: '',
                                                }}/>}/> 
                        <Route exact path="/privacy_statement" render={() => <Hotel_PrivacyStatement />}/> 
                        <Route exact path="/contact" render={() => <Contact_Us />}/> 
                        {/*<Route exact path="/logout" render={() => <ConfirmMerchantLogout  data={{
                                            acctID: acctID,
                                            schema: schema,
                                            sessionID: sessionID,
                        baseURL: baseURL}}/>}/> */}
                        <Route path="/offer_letter" render={() => <Applicant_OfferLetterModal openModal={ viewApplicant_OfferModal } closeModal={() => setViewApplicant_OfferModal(false)} data={{
                            applicant_merchant_accountID: applicant_merchantID,
                            applicant_requisitionID: applicant_requisitionID,
                            applicant_applicationID: applicant_applicationID,
                            status: 'user_applicant_offer',
                                                }}/>}/> 
                        <Route exact path="/jobs" render={() => <Home   data={{
                            status: 'public_jobs',
                                                }}/>} />
                        <Route exact path="/" render={() => <Home   data={{
                            status: '',
                                                }}/>} />
                    </IonRouterOutlet >
                    </IonReactRouter>

                </IonApp>; // or null
      }
    
    return (
            <IonApp>    
                <IonReactRouter>

                <IonSplitPane when="(min-width: 992px)" contentId="qavaAppConfirmed">

            {/* Single menu based on user type */}
            {authenticatedMerchent_context.authenticated === 'T1' && (
              <Hotel_SideMenu contentId="qavaAppConfirmed" menuId="side_menu_hotel" />
            )}
            {authenticatedMerchent_context.authenticated === 'T2' && (
              <ProService_SideMenu contentId="qavaAppConfirmed" menuId="side_menu_hotel" />
            )}
            {authenticatedMerchent_context.authenticated === 'T3' && (
              <Retail_SideMenu contentId="qavaAppConfirmed" menuId="side_menu_hotel" />
            )}
            {authenticatedMerchent_context.authenticated === 'T4' && (
              <JobBoard_SideMenu contentId="qavaAppConfirmed" menuId="side_menu_jobBoard" />
            )}
            {authenticatedMerchent_context.authenticated === 'C1' && (
              <Client_SideMenu contentId="qavaAppConfirmed" menuId="side_menu_hotel" />
            )}

            <div id="qavaAppConfirmed">

              <IonRouterOutlet >

                <>
                 {authenticatedMerchent_context.authenticated == 'T1' &&
                 <>
                    {(authenticatedMerchent_context.subscription.payStatus == 'pending' && authenticatedMerchent_context.subscription.transactionTotal > 100 && Date.now() > new Date(authenticatedMerchent_context.subscription.nextBillingDate).getTime()) && <Subscription_Alert openModal={ true } ></Subscription_Alert>}

                    <Push_Notification notificationData={(e) => setNotificationData(e)}></Push_Notification>

                    <PrivateRoute_merchant exact path="/" > <Hotel_MerchantHomePage /></PrivateRoute_merchant>                
                    <PrivateRoute_merchant exact path="/hotel_merchantMainPageApp" > <Hotel_MerchantHomePage /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/hotel_profileSetting" > <Internal_ProfileSetting /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/hotel_accountSetting" > <Hotel_AccountSetting /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/home" > <Home data={{
                                                    source: '',
                                                    }}/></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/jobs" > <Home data={{
                                                    source: 'public_jobs',
                                                    }}/></PrivateRoute_merchant>               
                </>

                 }

                 {authenticatedMerchent_context.authenticated == 'T2' &&
                 <>
                    <Push_Notification notificationData={(e) => setNotificationData(e)}></Push_Notification>

                    <PrivateRoute_merchant exact path="/"> <ProService_MerchantHomePage /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/proService_merchantMainPageApp"> <ProService_MerchantHomePage /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/proService_profileSetting"> <Internal_ProfileSetting /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/proService_accountSetting"> <ProService_AccountSetting /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/home" > <Home data={{
                                                    source: '',
                                                    }}/></PrivateRoute_merchant>    
                    <PrivateRoute_merchant exact path="/jobs" > <Home data={{
                                                    source: 'public_jobs',
                                                    }}/></PrivateRoute_merchant>               

                </>

                 }

                {authenticatedMerchent_context.authenticated == 'T3' &&
                 <>
                    {(authenticatedMerchent_context.subscription.payStatus == 'pending' && authenticatedMerchent_context.subscription.transactionTotal > 100 && Date.now() > new Date(authenticatedMerchent_context.subscription.nextBillingDate).getTime()) && <Subscription_Alert openModal={ true } ></Subscription_Alert>}

                    <Push_Notification notificationData={(e) => setNotificationData(e)}></Push_Notification>

                    <PrivateRoute_merchant exact path="/"> <Retail_MerchantHomePage /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/retail_merchantMainPageApp"> <Retail_MerchantHomePage /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/retail_profileSetting"> <Internal_ProfileSetting /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/retail_accountSetting"> <Retail_AccountSetting /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/retail_tutorials"> <Retail_Tutorials /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/home" > <Home data={{
                                                    source: '',
                                                    }}/></PrivateRoute_merchant>    
                    <PrivateRoute_merchant exact path="/jobs" > <Home data={{
                                                    source: 'public_jobs',
                                                    }}/></PrivateRoute_merchant>               

                </>

                 }

                {authenticatedMerchent_context.authenticated == 'T4' &&
                 <>
                    {(authenticatedMerchent_context.subscription.payStatus == 'pending' && authenticatedMerchent_context.subscription.transactionTotal > 100 && Date.now() > new Date(authenticatedMerchent_context.subscription.nextBillingDate).getTime()) && <Subscription_Alert openModal={ true } ></Subscription_Alert>}

                    <Push_Notification notificationData={(e) => setNotificationData(e)}></Push_Notification>

                    <PrivateRoute_merchant exact path="/"> <JobBoard_MerchantHomePage /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/jobBoard_merchantMainPageApp"> <JobBoard_MerchantHomePage /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/jobBoard_profileSetting"> <JobBoard_ProfileSetting /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/jobBoard_accountSetting"> <JobBoard_AccountSetting /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/jobBoard_tutorials"> <JobBoard_Tutorials /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/home" > <Home data={{
                                                    source: '',
                                                    }}/></PrivateRoute_merchant>      
                    <PrivateRoute_merchant exact path="/jobs" > <Home data={{
                                                    source: 'public_jobs',
                                                    }}/></PrivateRoute_merchant>             

                </>

                 }
                {authenticatedMerchent_context.authenticated == 'C1' &&
                 <>

                    <Push_Notification notificationData={(e) => setNotificationData(e)}></Push_Notification>

                    <PrivateRoute_merchant exact path="/"> <ClientHomePage data={{
                                                    source: '',
                                                    }}/></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/jobs"> <ClientHomePage data={{
                                                    source: 'online_application_register_completed',
                                                    }}/></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/clientMainPageApp"> <ClientHomePage data={{
                                                    source: '',
                                                    }}/></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/client_profileSetting"> <Client_ProfileSetting /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/client_accountSetting"> <Client_AccountSetting /></PrivateRoute_merchant>
                    <PrivateRoute_merchant exact path="/home" > <Home data={{
                                                    source: '',
                                                    }}/></PrivateRoute_merchant>                
                </>

                }

                
              {/*  {(authenticatedMerchent_context.loginUsername != null && authenticatedMerchent_context.sessionID == null) && <MerchantLoginCredentials openModal={ merchantLoginModal } closeModal={() => setMerchantLoginModal(false)} data={{
                                                        source: '', 
                                                        }}></MerchantLoginCredentials>}

                {(authenticatedMerchent_context.authenticated != null && window.location.pathname == '/logout') && <ConfirmMerchantLogout ></ConfirmMerchantLogout>}

{window.location.pathname.includes('offer_letter') && <Applicant_OfferLetterModal openModal={ viewApplicant_OfferModal } closeModal={() => setViewApplicant_OfferModal(false)} data={{
                    applicant_merchant_accountID: applicant_merchantID,
                    applicant_requisitionID: applicant_requisitionID,
                    applicant_applicationID: applicant_applicationID,
                    status: 'user_applicant_offer',
                                        }}></Applicant_OfferLetterModal>}                                    */}
                    </>
                </IonRouterOutlet>
                </div>

                </IonSplitPane>
                </IonReactRouter>
            </IonApp>



        )
}

//Notes

export default App;
